import {useState, useEffect, useRef} from "react";
import Modal from "../../custom/Modal/Modal.jsx";
import "./LastVisits.css";
import Icon from "../../common/Icon/Icon";
import {Download, Exit, Upload} from "../../../Assets/SVGS.jsx";
import Table from "../../custom/Table/Table";
import {ToastContainer} from "react-toastify";
import getData from "../../../utils/getData.js";
import donwloadImage from "../../../utils/downloadImage.js";
import img from '../../../Assets/Images/rosheta1.jpg'
import axios from "axios";
import base_url from "../../../config/base_url.js";
import handleApiError from "../../../utils/handleApiError.js";
import { useTranslation } from 'react-i18next';
function LastVisits() {
  const { t } = useTranslation();
  const token = localStorage.getItem("token")
  const uploadRef = useRef("")
  const [loader, setLoader] = useState(false);
  const [patientRecords, setPatientRecords] = useState(null);
  const [attachments, setAttachments] = useState();
  const [rowData , setRowData] = useState(null)
  const [attachmentsModal, setAttachmentsModal] = useState(false);
  const [uploadModal , setUploadModal] = useState(false)
  const [uploadedImages , setUploadedImages] = useState([])

  const ShowAttachments = (attachment) => {
    setAttachments(attachment);
    setAttachmentsModal(true);
  };
  
  const ShowUploadModal = (item) =>{
    setRowData(item)
    setUploadModal(true)
    
  }

  const handleRemoveImage = (index)=>{
    setUploadedImages(prevImages => {
      // نستخدم دالة filter لإنشاء مصفوفة جديدة تستثني العنصر الذي يتطابق فهرسه
      const updatedImages = prevImages.filter((_, i) => i !== index);
      
      // **ملاحظة هامة:** يجب أيضاً إلغاء الـ URL المؤقت لتحرير الذاكرة
      // (إذا كنت تستخدمه كما في الكود السابق)
      // إذا كنت تريد تحرير الذاكرة هنا:
      // URL.revokeObjectURL(prevImages[indexToRemove].path_or_url); 
      // لكن هذا قد يكون معقداً قليلاً، لذلك نركز على الحذف من الـ State أولاً.

      return updatedImages;
  });

  }

  const handleUploadFiles = async()=>{
    const formData = new FormData();
    uploadedImages.forEach((file, index) => {
      formData.append("files", file, file.name);
    });
    try{
      const res = await axios.put(`${base_url}/medical-history/${rowData?.id}`, formData ,{
        headers:{
          Authorization: `Bearer ${token} `,
        }
      })
    }
    catch(error){
      handleApiError(error)
    }
    finally{
      setUploadedImages([])
    }
  }

  const getMyMedicalVisits = async () => {
    setLoader(true);
    const res = await getData('medical-history/my-medical-histories')
    setPatientRecords(res?.data?.data);
    setLoader(false);
  };

  useEffect(() => {
    getMyMedicalVisits();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className='lastVisits-container container'>
        <div className='lastVisits-content content'>
          <Table
            data={patientRecords}
            headers={[
              t('date'),
              t('doctor'),
              t('diagnosis'),
              t('treatments'),
              t('notesLabel'),
              t('attachments'),
            ]}
            keys={["date", "doctor", "diagnosis", "treatment", "notes"]}
            renderAction={(item) => (
              <td className='btns'>
                <button
                  className='detailsBtn'
                  onClick={() => ShowAttachments(item.attachments)}
                >
                  {t('view')}
                </button>
                <button
                  className='addBtn'
                  onClick={() => ShowUploadModal(item)}
                >
                  {t('upload')}
                </button>
              </td>
            )}
            loader={loader}
          />
          <Modal isOpen={attachmentsModal}>
            <div className='modal-header'>
              <h3>{t('attachments')}</h3>
              <div className='icon' onClick={() => setAttachmentsModal(false)}>
                <Icon icon={<Exit width='30px' />} />
              </div>
            </div>

            <div className='images'>
              {attachments?.length > 0 ? (
                attachments?.map((item, index) => {
                  return (
                    <div className='image' key={index}>
                      <img src={img} alt='attachment' />
                      <span className='img-label'>
                        {t('attachment')} {index + 1}
                      </span>
                      <Icon icon={<Download />} func={() => donwloadImage()} />
                    </div>
                  );
                })
              ) : (
                <div className='no-data'>
                  <h4>{t('noAttachments')}</h4>
                </div>
              )}
            </div>
          </Modal>

          <Modal isOpen={uploadModal}>
            <div className='modal-header'>
              <h3>{t('uploadYourImages')}</h3>
              <div className='icon' onClick={() => setUploadModal(false)}>
                <Icon icon={<Exit width='30px' />} />
              </div>
            </div>
            <div className='uploadArea'>
              <input
                style={{display: "none"}}
                type='file'
                multiple
                onChange={(e) => {
                  const newFiles = [...e.target.files];
                  setUploadedImages(prev=>{
                    return [...prev, ...newFiles];
                  });
                }}
                ref={uploadRef}
              />
              <div className='dropzone' onClick={() => uploadRef.current.click()}>
                <Icon icon={<Upload width='64px' />} />
                <h3>{t('uploadYourImages')}</h3>
                <p>{t('chooseImagesToUpload')}</p>
              </div>

              {uploadedImages.length > 0 && (
                <div className='uploadedPreview'>
                  <p className='preview-title'>{t('selectedFiles')} ({uploadedImages.length})</p>
                  <div className='uploadedImages'>
                    {uploadedImages.map((item , index) => (
                      <div className="image" key={index}>
                        <img src={URL.createObjectURL(item)} alt='attachment' />
                        <span className="imageOverLay" onClick={()=>handleRemoveImage(index)}>
                          <Exit width="15px"/>
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className='uploadBtn'>
              <button className="addBtn" disabled={uploadedImages.length === 0} onClick={()=>handleUploadFiles()}>
                <Upload width="20px" />
                {t('uploadFile')}
              </button>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
}
export default LastVisits;
